import { Action } from '@ngrx/store';
import { NavItemPrimaryInterface } from 'app/app-layout/models';

import { NavItemsActionType } from './nav-items-action-type.enum';

export class NavItemsLoad implements Action {
  public readonly type: NavItemsActionType = NavItemsActionType.LoadNavItems;

  constructor(public readonly payload: string) {}
}

export class NavItemsLoadCompleted implements Action {
  public readonly type: NavItemsActionType = NavItemsActionType.LoadNavItemsCompleted;

  constructor(public readonly payload: NavItemPrimaryInterface[]) { }
}

export class NavItemsLoadFailed implements Action {
  public readonly type: NavItemsActionType = NavItemsActionType.LoadNavItemsFailed;

  constructor(public readonly payload: string) { }
}
